const style = {
  main: {
    sx: {
      borderRadius: 1,
      backgroundColor: '#F3F4F6',
      mt: 1,
      ml: 0,
    },
  },
  text: {
    variant: 'subtitle1',
    sx: {
      pt: 3,
    },
  },
  cardBox: {
    display: 'flex',
    justifyContent: 'space-between',
    pt: 3,
  },
  skelaton: {
    width: 130,
    height: 69,
    variant: 'rectangular',
    sx: { m: 0.1 },
  },
} as const;

export default style;
